// Shared "create site onboarding" AB-test constants. Must be identical across apps (websites &
// mini-landing) — the URL param and the GTM experiment id are assigned by the backend, not per app.
// Storage keys stay app-specific (see each app's OnboardingWizardAbTestService) so site ids from
// different apps can't collide.

export const ONBOARDING_WIZARD_QUERY_PARAM = 'isOnboardingWizard';
export const ONBOARDING_WIZARD_EXPERIMENT = 'low.1';
